export const URL_INVALID = 'Enter correct URL. For example: gpdigitalcards.com';
export const WHATSAPP_URL_INVALID = 'Enter correct URL. For example: wa.me/<phone>';
export const UNVALID_EMAIL = 'Enter correct email.';
export const REQUIRED_FIELD = `Field can't be empty`;
export const INCORECT_PHONE = 'Phone number is invalid';
export const PHONE_ERROR_INT_FORMAT = 'Please enter the number in the international format';
export const PHONE_ERROR_MOBILE_TYPE = 'Please enter a mobile number';

export const NULL_PAYLOAD = 'Error! GraphQL query payload is null.';
